export default __webpack_public_path__ + "static/profile-avatar-2-90fab72653f9584727aa211ddd2397c3.png";